import Column from '@components/column'
import Row from '@components/row'
import Svg from '@components/svg'
import Stats from './stats'
import Banner from './banner'
import SectionHeading from '@commons/headings/section'
import Tabs from '@commons/tabs'
import Search from '@commons/search'
import Button from '@components/button'
import Services from './services'
import Orders from './orders'
import { useNavigate } from 'react-router-dom'
import { InstituteHealthService } from '@apis'
import { useSelector } from 'react-redux'

const InstituteHealthServicesPage = () => {
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  const tabs = [
    {
      title: 'All Services',
      key: 'services',
      Component: Services,
    },
    {
      title: 'Service Order',
      key: 'orders',
      Component: Orders,
    },
  ]
  const handleSearchSubmit = async (search) => {
    const params = {
      page: 1,
      limit: 6,
      userId: user?.id,
      search: search,
    }
    await InstituteHealthService.list({
      params: params,
    }).catch(() => {})
  }

  const handleClickCreate = () => {
    navigate('/institution/health-services/create')
  }
  return (
    <Column rowGap={20}>
      <Stats />
      <Banner />
      <Column rowGap={20}>
        <SectionHeading title="Our Healthcare Service" />
        <Tabs
          items={tabs}
          rightComponent={
            <Row colGap={20}>
              <Search onSubmit={handleSearchSubmit} />
              <Button
                leftComponent={<Svg svg="circlePlus" color={'white'} />}
                onClick={handleClickCreate}
                title={`Create New Service`}
                height={45}
              />
            </Row>
          }
        />
      </Column>
    </Column>
  )
}

export default InstituteHealthServicesPage
